<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Nature of Loss 1 Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.nol1 }}</td>
            <td class="text-xs-left">{{ props.item.nol1ShortDesc }}</td>
            <td class="text-xs-left">{{ props.item.nol1LongDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['claimReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Nature of Loss 1
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Nature of Loss 1? ({{deleteClmNol1}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Nature of Loss', align: 'left', value: 'nol1' },
        { text: 'Short Description', align: 'left', value: 'nol1ShortDesc' },
        { text: 'Long Description', align: 'left', value: 'nol1LongDesc' }
      ],
      loading: false,
      promptRemove: false,
      selectedClmNol1: undefined,
      deleteClmNol1: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmNol1s
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((ClmNol1) => {
              const convertClmNol1 = {
                nol1: ClmNol1.nol1,
                nol1ShortDesc: ClmNol1.nol1ShortDesc,
                nol1LongDesc: ClmNol1.nol1LongDesc
              }
              this.items.push(convertClmNol1)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(data) {
      if (data && data.item) {
        this.$router.push({ name: 'clmNolReview', params: { nol1: data.item.nol1 } })
      } else {
        this.errorMessage('Invalid Item')
      }
    },
    doNew() {
      this.$router.push({ name: 'clmNolReview', params: { nol1: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedClmNol1 = data
        this.deleteClmNol1 = data.nol1 + ' - ' + data.nol1ShortDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.claimParam.menu.deleteClmNOL1
      if (apiURI) {
        const expand = this.selectedClmNol1
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['claimReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
